export default __webpack_public_path__ + "static/media/list-icon.047fc7fa.svg";